import { name, jobTitle, skills, level, birthYear } from "./validations";

export const EmployeeValidate = {
  name,
  jobTitle,
  skills,
  level,
  birthYear,
};
